import type React from "react";

/**
 * Carrega um componente de página dinamicamente para uso com React.lazy.
 * Esta versão é totalmente dinâmica e não depende de uma lista fixa.
 * @param nomePagina O nome do arquivo da página (ex: "HomePage.tsx").
 * @returns Uma Promise que resolve para o módulo da página.
 */
export const carregarPagina = (nomePagina: string): Promise<{ default: React.ComponentType<any> }> => {
  
  if (!nomePagina) {
    console.error(`[Loader] Tentativa de carregar uma página com nome vazio.`);
    return Promise.reject(new Error(`Nome de página inválido`));
  }

  // Remove a extensão .tsx para usar no caminho do import
  const nomeBase = nomePagina.replace(".tsx", "");

  console.log(`[Loader] Carregando página: ../paginas/${nomeBase}.tsx`);

  // A função import() dinâmica do JavaScript fará o resto.
  // O bundler (Vite/Webpack) irá mapear todos os arquivos possíveis na pasta /paginas.
  return import(`../paginas/${nomeBase}.tsx`);
};
